export const MODULE_NAME = 'projects';